package com.exura.features.plandefinition.data.repository

import com.exura.features.firebase.domain.model.versioning.Version
import com.exura.features.firebase.domain.repository.UserPrefixedRepository
import com.exura.features.firebase.domain.repository.versioning.Versioned
import com.exura.features.firebase.usecase.GetUserDataPrefixUseCase
import com.exura.features.plandefinition.domain.model.metadata.PlanDefinitionFields
import com.exura.features.plandefinition.domain.model.metadata.PlanDefinitionMetadata
import com.exura.features.plandefinition.domain.model.metadata.PlanDefinitionStatistics
import com.exura.features.plandefinition.domain.model.plan.BasePlan
import com.exura.features.plandefinition.domain.model.series.SeriesSpawnType
import com.exura.features.plandefinition.domain.repository.PlanDefinitionRepository
import com.exura.features.plandefinition.domain.repository.PlanVersionRepository
import com.exura.features.plandefinition.domain.repository.ProviderVersionedTreatmentRepository
import com.exura.features.plandefinition.domain.repository.VersionedPlanDefinitionRepository


class PlanDefinitionVersioned(
    override val itemRepository: PlanDefinitionRepository,
    versionsRepository: PlanVersionRepository,
    getUserDataPrefixUseCase: GetUserDataPrefixUseCase,
) : VersionedPlanDefinitionRepository, Versioned<BasePlan, PlanDefinitionMetadata>(
    itemRepository = itemRepository,
    versionBaseRepository = versionsRepository,
    getDataPrefix = suspend { getUserDataPrefixUseCase() },
    versionCollectionName = FirebaseColls.V_TREATMENT_PLAN,
) {
    override suspend fun createItemMetadata(item: BasePlan): PlanDefinitionMetadata = PlanDefinitionMetadata(
        fields = PlanDefinitionFields(
            title = item.title,
            description = item.description,
            imageUrl = item.imageUrl,
        ),
        statistics = item.calculateStatistics(),
    )
}

fun BasePlan.calculateStatistics(): PlanDefinitionStatistics {
    val seriesCounts = countSeriesByType()

    return PlanDefinitionStatistics(
        numberFloating = seriesCounts[SeriesSpawnType.FLOATING] ?: 0,
        numberQuestion = seriesCounts[SeriesSpawnType.QUESTION] ?: 0,
        numberPersistent = seriesCounts[SeriesSpawnType.PERSISTENT] ?: 0,
        numberInstruction = seriesCounts[SeriesSpawnType.INSTRUCTION] ?: 0,
        planDuration = this.durationInDays(),
    )
}


class ProviderVersionedTreatmentRepositoryImpl(
    private val planRepository: VersionedPlanDefinitionRepository,
    getUserDataPrefixUseCase: GetUserDataPrefixUseCase,
) : ProviderVersionedTreatmentRepository, UserPrefixedRepository<BasePlan, Version<BasePlan, PlanDefinitionMetadata>> (
    baseRepository = planRepository,
    getDataPrefix = suspend { getUserDataPrefixUseCase() },
    collectionName = FirebaseColls.TREATMENT_PLAN,
) {
    override suspend fun getContent(version: Version<BasePlan, PlanDefinitionMetadata>): BasePlan = version.getContent(planRepository.itemRepository)
}
